import { createSelector } from "reselect";
import { getCurrentContext } from "state/auth/selectors/common";
import { CLUSTER_PROFILE_CONTEXT_OPTIONS } from "utils/constants";

export const getContextOptions = createSelector(
  getCurrentContext,
  (context) => {
    if (!context?.isAdmin) return CLUSTER_PROFILE_CONTEXT_OPTIONS;
    return CLUSTER_PROFILE_CONTEXT_OPTIONS.filter(
      (option) => option.value !== "project"
    );
  }
);
